import { ArrowLeft } from 'lucide-react'
import { useParams } from 'react-router'

import { Button } from '@/ui-components/Button'
import { Heading } from '@/ui-components/Heading'
import AccountCapabilities from '@/views/GlobalAccountDetails/AccountCapabilities'
import type { AccountCapabilitiesData } from '@/views/GlobalAccountDetails/AccountCapabilities'
import AccountDetails from '@/views/GlobalAccountDetails/AccountDetails'

const MOCK_ACCOUNT_DETAILS = {
  accountName: 'ACC-Rosenbaum, Hirthe and Wiegand Melbourne',
  accountNumber: '993377178',
  bankCode: '016',
  branchCode: '478',
  swiftCode: 'DHBKHKHH',
  bankName: 'DBS Bank (Hong Kong) Ltd',
  bankAddress: "18th Floor, The Center, 99 Queen's Road Central, Central",
  bankLocation: 'Hong Kong (China)',
}

const GlobalAccountsDetailsPage: React.FC = () => {
  const { globalAccountId } = useParams()
  const globalAccountCapabilities: AccountCapabilitiesData = {
    acceptFundsVia: [
      {
        method: 'Domestic Bank Transfer',
        daysToComplete: '0-1 days',
        active: true,
      },
      {
        method: 'International SWIFT Transfer',
        daysToComplete: '1-2 days',
        active: false,
      },
    ],
    payoutVia: [
      {
        method: 'BECS direct debit',
        active: true,
      },
      {
        method: 'SEPA direct debit',
        active: false,
      },
      {
        method: 'CHAPS',
        active: false,
      },
    ],
  }

  return (
    <>
      <Button
        plain
        className="mb-2"
        to="/wallet"
        aria-label="Go back"
      >
        <ArrowLeft data-slot="icon" />
        Back
      </Button>

      <Heading
        className="mb-4"
        level={3}
      >
        Account Details for {globalAccountId}
      </Heading>

      <AccountCapabilities data={globalAccountCapabilities} />

      <AccountDetails data={MOCK_ACCOUNT_DETAILS} />
    </>
  )
}

export default GlobalAccountsDetailsPage
